/* eslint-disable react/no-unused-state */
import * as partnerPlanStatusFormSchema from 'schemas/forms/PartnerPlanStatusForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import { validateAll } from 'utils/validators'
import { commonFunctions } from 'utils/CommonFunctions'
import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import SelectInput from 'components/Form/components/SelectInput'
import Checkbox from 'components/Form/components/Checkbox'
import SubmitButton from 'components/SubmitButton'
import Alert from 'components/Alert'
import constants from 'constants'
import styles from './PartnerPlanStatusDisplayForm.scss'
// import moment from 'moment'
import { format } from 'date-fns'
import { hasAccess } from 'utils/hasAccess'
import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

class PartnerPlanStatusDisplayForm extends Component {
  static propTypes = {
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    currentUser: PropTypes.object.isRequired,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    partnerPlan: PropTypes.object,
    partnerPlans: PropTypes.object,
    partnerPlanStatusForm: PropTypes.object,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }
  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    description: '',
    id: 'partnerPlanStatusForm',
    title: '',
    handleFormSubmit: null,
    partnerPlan: null,
    partnerPlans: null,
    partnerPlanStatusForm: null,
  }
  constructor(props) {
    super(props)
    this.state = {
      employeeId: '',
      financialYearSelected: '',
      planStatusSelected: '',
      planStatusExemptOtherSelected: false,
      selectedPlan: {},
    }
  }

  componentWillMount() {
    const { formFields } = partnerPlanStatusFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }
    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.partnerPlanStatusForm
    const modalChanged = modalCreated && nextProps.modals.partnerPlanStatusForm.show !== this.props.modals.partnerPlanStatusForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.partnerPlanStatusForm.show
    const modalVisible = modalCreated && nextProps.modals.partnerPlanStatusForm.show
    // const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      this.setState({ financialYearSelected: '' })
      this.setState({ planStatusSelected: '' })
      this.setState({ planStatusExemptSelected: '' })
      // preload data from BED if needed
      const selectedPartner = JSON.parse(sessionStorage.getItem('SelectedPartner'))
      this._handleChange('partnerName', selectedPartner.Name)
      this.setState({ employeeId: selectedPartner.EmployeeId })
    }
  }

  _schema = () => {
    const obj = {}
    partnerPlanStatusFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })

    // Validate all the forms fields and return any errors
    const errors = validateAll(partnerPlanStatusFormSchema.requiredFields, this.props.forms[this.props.id])

    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      // append or map existing data
      // data.partnerName = this.props.accountsAndLoans.bankTransferAccounts[0].partnerName
      // data.transferrequesttype = this.state.toAccountSelected
      const formData = {
        employee_id: this.state.selectedPlan.employeeId,
        loginname: '', // loginname is stored on the webapi server session
        year: data.financialYear,
        interimCounsellee: (this.state.selectedPlan.interimCounsellee ? this.state.selectedPlan.interimCounsellee : ''),
        interimCounselleeComments: (this.state.selectedPlan.interimCounselleeComments ? this.state.selectedPlan.interimCounselleeComments : ''),
        interimCounsellor: (this.state.selectedPlan.interimCounsellor ? this.state.selectedPlan.interimCounsellor : ''),
        interimCounsellorComments: (this.state.selectedPlan.interimCounsellorComments ? this.state.selectedPlan.interimCounsellorComments : ''),
        interimAgreedDate: (this.state.selectedPlan.interimAgreedDate ? this.state.selectedPlan.interimAgreedDate : ''),
        finalCounselleeAssessment: (this.state.selectedPlan.finalCounselleeAssessment ? this.state.selectedPlan.finalCounselleeAssessment : ''),
        finalCounselleeComments: (this.state.selectedPlan.finalCounselleeComments ? this.state.selectedPlan.finalCounselleeComments : ''),
        finalCounsellorAssessment: (this.state.selectedPlan.finalCounsellorAssessment ? this.state.selectedPlan.finalCounsellorAssessment : ''),
        finalCounsellorComments: (this.state.selectedPlan.finalCounsellorComments ? this.state.selectedPlan.finalCounsellorComments : ''),
        finalAgreedDate: (this.state.selectedPlan.finalAgreedDate ? this.state.selectedPlan.finalAgreedDate : ''),
        planStatus: data.planStatus,
        /* lastModifiedBy: (this.props.currentUser.IsAdmin ? constants.PARTNERPLAN.MODIFIED_BY_ADMIN : commonFunctions.iff(
          (this.props.currentUser.GivenName && this.props.currentUser.Surname),
          `${this.props.currentUser.GivenName} ${this.props.currentUser.Surname}`, this.props.currentUser.DisplayName,
        )), */
        lastModifiedBy: (commonFunctions.isAdminPortal() ? constants.PARTNERPLAN.MODIFIED_BY_ADMIN : commonFunctions.iff(
          (this.props.currentUser.GivenName && this.props.currentUser.Surname),
          `${this.props.currentUser.GivenName} ${this.props.currentUser.Surname}`, this.props.currentUser.DisplayName,
        )),
        planAgreedDate: (this.state.selectedPlan.planAgreedDate ? this.state.selectedPlan.planAgreedDate : ''),
        planSubmittedDate: (this.state.selectedPlan.planSubmittedDate ? this.state.selectedPlan.planSubmittedDate : ''),
        planUploadedDate: (this.state.selectedPlan.planUploadedDate ? this.state.selectedPlan.planUploadedDate : ''),
        interimDate: (this.state.selectedPlan.interimDate ? this.state.selectedPlan.interimDate : ''),
        finalDate: (this.state.selectedPlan.finalDate ? this.state.selectedPlan.finalDate : ''),
        // notification requirement
        cpEmpId: (this.state.selectedPlan.cpEmpId ? this.state.selectedPlan.cpEmpId : ''),
        cpEmail: (this.state.selectedPlan.cpEmail ? this.state.selectedPlan.cpEmail : ''),
        cpName: (this.state.selectedPlan.cpName ? this.state.selectedPlan.cpName : ''),
        mlEmpId: (this.state.selectedPlan.mlEmpId ? this.state.selectedPlan.mlEmpId : ''),
        mlEmail: (this.state.selectedPlan.mlEmail ? this.state.selectedPlan.mlEmail : ''),
        mlName: (this.state.selectedPlan.mlName ? this.state.selectedPlan.mlName : ''),
        blEmpId: (this.state.selectedPlan.blEmpId ? this.state.selectedPlan.blEmpId : ''),
        blEmail: (this.state.selectedPlan.blEmail ? this.state.selectedPlan.blEmail : ''),
        blName: (this.state.selectedPlan.blName ? this.state.selectedPlan.blName : ''),
        cilEmpId: (this.state.selectedPlan.cilEmpId ? this.state.selectedPlan.cilEmpId : ''),
        cilEmail: (this.state.selectedPlan.cilEmail ? this.state.selectedPlan.cilEmail : ''),
        cilName: (this.state.selectedPlan.cilName ? this.state.selectedPlan.cilName : ''),
        bucooEmail: (this.state.selectedPlan.BUCOOEmail ? this.state.selectedPlan.BUCOOEmail : ''),
        oplEmail: (this.state.selectedPlan.OPLEmail ? this.state.selectedPlan.OPLEmail : ''),
        olEmail: (this.state.selectedPlan.OLEmail ? this.state.selectedPlan.OLEmail : ''),
        adminComments: (this.state.selectedPlan.adminComments ? this.state.selectedPlan.adminComments : ''),
        planAgreedWithCounsellee: (this.state.selectedPlan.planAgreedWithCounsellee ? this.state.selectedPlan.planAgreedWithCounsellee : ''),
        interimPlanAgreedWithCounsellee: (this.state.selectedPlan.interimPlanAgreedWithCounsellee ? this.state.selectedPlan.interimPlanAgreedWithCounsellee : ''),
        finalPlanAgreedWithCounsellee: (this.state.selectedPlan.finalPlanAgreedWithCounsellee ? this.state.selectedPlan.finalPlanAgreedWithCounsellee : ''),
        // servicearealeaderComments: (this.state.selectedPlan.ServiceAreaLeaderComments ? this.state.selectedPlan.ServiceAreaLeaderComments : ''), --put on hold
      }
      switch (data.planStatus) {
        case constants.PARTNERPLAN.STATUS.DRAFT:
        case constants.PARTNERPLAN.STATUS.UPLOADED:
          formData.planAgreedDate = ''
          formData.planAgreedWithCounsellee = ''
          formData.planSubmittedDate = ''
          // formData.planUploadedDate = (data.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED) ? `${moment(new Date()).format()}` : ''
          formData.planUploadedDate = (data.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED) ? `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}` : ''
          formData.adminComments = ''
          break
        case constants.PARTNERPLAN.STATUS.SUBMITTED:
          formData.planAgreedDate = ''
          formData.planAgreedWithCounsellee = ''
          // formData.planSubmittedDate = `${moment(new Date()).format()}`
          formData.planSubmittedDate = `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}`
          formData.adminComments = ''
          break
        case constants.PARTNERPLAN.STATUS.AGREED:
          // formData.planAgreedDate = `${moment(new Date()).format()}`
          formData.planAgreedWithCounsellee = data.planAgreedWithCounsellee
          formData.planAgreedDate = `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}`
          formData.adminComments = ''
          break
        case constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT:
        case constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED:
          // formData.interimDate = `${moment(new Date()).format()}`
          formData.interimDate = `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}`
          formData.interimCounsellee = (data.planRating ? data.planRating : '')
          formData.interimCounselleeComments = (data.note ? data.note : '')
          formData.adminComments = ''
          formData.interimPlanAgreedWithCounsellee = ''
          formData.finalPlanAgreedWithCounsellee = ''          
          break
        case constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED:
          // formData.interimAgreedDate = `${moment(new Date()).format()}`
          formData.interimPlanAgreedWithCounsellee = data.planAgreedWithCounsellee
          formData.interimAgreedDate = `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}`
          formData.interimCounsellor = (data.planRating ? data.planRating : '')
          formData.interimCounsellorComments = (data.note ? data.note : '')
          formData.adminComments = ''
          break
        case constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT:
        case constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED:
          // formData.finalDate = `${moment(new Date()).format()}`
          formData.finalDate = `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}`
          formData.finalCounselleeAssessment = (data.planRating ? data.planRating : '')
          formData.finalCounselleeComments = (data.note ? data.note : '')
          formData.adminComments = ''
          formData.finalPlanAgreedWithCounsellee = ''
          break
        case constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED:
          // formData.finalAgreedDate = `${moment(new Date()).format()}`
          formData.finalPlanAgreedWithCounsellee = data.planAgreedWithCounsellee
          formData.finalAgreedDate = `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}`
          formData.finalCounsellorAssessment = (data.planRating ? data.planRating : '')
          formData.finalCounsellorComments = (data.note ? data.note : '')
          formData.adminComments = ''
          break
        case constants.PARTNERPLAN.STATUS.EXEMPT:
          formData.adminComments = (data.planExemption ? data.planExemption : '')
          if (data.planExemption === 'Other') {
            formData.adminComments = `${data.planExemption}:${data.planExemptionOther}`
          }
          break
        default:
      }
      if (data.planStatus === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT) {
        formData.finalDate = ''
      }
      if (data.planStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT) {
        formData.interimDate = ''
        formData.interimPlanAgreedWithCounsellee = ''
        formData.finalPlanAgreedWithCounsellee = ''
      }

      if (data.planStatus === constants.PARTNERPLAN.STATUS.DRAFT || data.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED ||
        data.planStatus === constants.PARTNERPLAN.STATUS.SUBMITTED || data.planStatus === constants.PARTNERPLAN.STATUS.AGREED) {
        formData.interimCounsellee = ''
        formData.interimCounselleeComments = ''
        formData.interimDate = ''
        formData.interimCounsellor = ''
        formData.interimCounsellorComments = ''
        formData.interimAgreedDate = ''
        formData.finalCounselleeAssessment = ''
        formData.finalCounselleeComments = ''
        formData.finalDate = ''
        formData.finalCounsellorAssessment = ''
        formData.finalCounsellorComments = ''
        formData.finalAgreedDate = ''
        formData.adminComments = ''
        formData.interimPlanAgreedWithCounsellee = ''
        formData.finalPlanAgreedWithCounsellee = ''
      }
      this.props.dispatch(formSubmit(this.props.id))
      this.props.handleSubmit(formData)
    }
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSelectChange = (name, value, selectedIndex) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }

    switch (name) {
      case 'financialYear': {
        this.setState({ financialYearSelected: value })
        // eslint-disable-next-line eqeqeq
        const filteredPlan = this.props.partnerPlans.partnerPlans.filter(plan => plan.year == value.trim())
        if (filteredPlan.length > 0) {
          this.setState({ selectedPlan: filteredPlan[0] }, () => {
            this._handleSelectChange('planStatus', (filteredPlan[0].planStatus !== '' ? filteredPlan[0].planStatus : ''))
          })
        }
        break
      }
      case 'planStatus':
        this.setState({ planStatusSelected: value })
        if (value === constants.PARTNERPLAN.STATUS.AGREED) {
          this._handleSelectChange('planAgreedWithCounsellee', (this.state.selectedPlan.planAgreedWithCounsellee !== ''
            ? this.state.selectedPlan.planAgreedWithCounsellee : ''))
        }
        if (value === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED) {
          this._handleSelectChange('planRating', (this.state.selectedPlan.interimCounsellee !== ''
            ? this.state.selectedPlan.interimCounsellee : ''))
          this._handleSelectChange('note', (this.state.selectedPlan.interimCounselleeComments !== ''
            ? this.state.selectedPlan.interimCounselleeComments : ''))
        }
        if (value === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED) {
          this._handleSelectChange('planRating', (this.state.selectedPlan.interimCounsellor !== ''
            ? this.state.selectedPlan.interimCounsellor : ''))
          this._handleSelectChange('note', (this.state.selectedPlan.interimCounsellorComments !== ''
            ? this.state.selectedPlan.interimCounsellorComments : ''))
          this._handleSelectChange('planAgreedWithCounsellee', (this.state.selectedPlan.interimPlanAgreedWithCounsellee !== ''
            ? this.state.selectedPlan.interimPlanAgreedWithCounsellee : ''))
        }
        if (value === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED) {
          this._handleSelectChange('planRating', (this.state.selectedPlan.finalCounselleeAssessment !== ''
            ? this.state.selectedPlan.finalCounselleeAssessment : ''))
          this._handleSelectChange('note', (this.state.selectedPlan.finalCounselleeComments !== ''
            ? this.state.selectedPlan.finalCounselleeComments : ''))
        }
        if (value === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED) {
          this._handleSelectChange('planRating', (this.state.selectedPlan.finalCounsellorAssessment !== ''
            ? this.state.selectedPlan.finalCounsellorAssessment : ''))
          this._handleSelectChange('note', (this.state.selectedPlan.finalCounsellorComments !== ''
            ? this.state.selectedPlan.finalCounsellorComments : ''))
          this._handleSelectChange('planAgreedWithCounsellee', (this.state.selectedPlan.finalPlanAgreedWithCounsellee !== ''
            ? this.state.selectedPlan.finalPlanAgreedWithCounsellee : ''))
        }
        if (value === constants.PARTNERPLAN.STATUS.EXEMPT) {
          if (this.state.selectedPlan.adminComments) {
            const exemptionComment = this.state.selectedPlan.adminComments.split(':')
            if (exemptionComment) {
              this.setState({ planStatusExemptOtherSelected: true })
              this._handleSelectChange('planExemptionOther', (exemptionComment[1] !== ''
                ? exemptionComment[1] : ''))
              this._handleSelectChange('planExemption', (exemptionComment[0] !== ''
                ? exemptionComment[0].trim() : ''))
            } else {
              this.setState({ planStatusExemptOtherSelected: false })
              this._handleSelectChange('planExemption', (this.state.selectedPlan.adminComments !== ''
                ? this.state.selectedPlan.adminComments : ''))
            }
          }
        }
        break
      case 'planExemption':
        this.setState({ planStatusExemptOtherSelected: false })
        if (value && value.indexOf('Other') > -1) {
          this.setState({ planStatusExemptOtherSelected: true })
        }
        break
      default:
        break
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]

    switch (this.state.planStatusSelected) {
      case constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED:
      case constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED:
      case constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED:
      case constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED:
        return form.partnerName.value && form.financialYear.value && form.planStatus.value
          && form.planRating.value && hasAccess(this.props.currentUser, 'ADMN: Update plan status', this.props.history, 'RW', false)
      default:
        return form.partnerName.value && form.financialYear.value && form.planStatus.value && hasAccess(this.props.currentUser, 'ADMN: Update plan status', this.props.history, 'RW', false)
    }
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      modals,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    const formHasFetched = this.props.hasFetched
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id="partnerPlanStatusForm"
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          {!hasAccess(this.props.currentUser, 'ADMN: Update plan status', this.props.history, 'RW', false) && <Alert type="error">
          Insufficient access to update plan status.
          </Alert> }
          <Alert type="info">
          Moving back plan status will clear any previously selected ratings/comments
          </Alert>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader} />
            <fieldset>
              <ul>
                <li>
                  <TextInput
                    {...schema.partnerName}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.partnerName.value}
                  />
                  <SelectInput
                    {...schema.financialYear}
                    searchable
                    error={form.financialYear.error}
                    handleChange={this._handleSelectChange}
                    onBlur={this._handleValidation}
                    options={this.props.partnerPlans.planYear} // load from BED?
                    valid={form.financialYear.valid}
                    value={form.financialYear.value}
                  />
                </li>
                <li>
                  <SelectInput
                    {...schema.planStatus}
                    error={form.planStatus.error}
                    floatedLabel
                    handleChange={this._handleSelectChange}
                    onBlur={this._handleValidation}
                    options={constants.PARTNERPLAN_LIST_OPTIONS.STATUS} // load from BED?
                    searchable
                    valid={form.planStatus.valid}
                    value={form.planStatus.value}
                  />
                </li>
                { (this.state.planStatusSelected === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED
                    || this.state.planStatusSelected === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED
                    || this.state.planStatusSelected === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED
                    || this.state.planStatusSelected === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED) &&
                    <li>
                      <SelectInput
                        {...schema.planRating}
                        error={form.planRating.error}
                        floatedLabel
                        handleChange={this._handleSelectChange}
                        onBlur={this._handleValidation}
                        options={constants.PARTNERPLAN_LIST_OPTIONS.RATINGS} // load from BED?
                        searchable
                        valid={form.planRating.valid}
                        value={form.planRating.value}
                      />
                      <TextInput
                        {...schema.note}
                        multiline
                        error={form.note.error}
                        focus={form.note.focus}
                        handleChange={this._handleChange}
                        onBlur={this._handleValidation}
                        onFocus={this._handleFocus}
                        text={form.note.value}
                        valid={form.note.valid}
                      />
                    </li>
                }
                { (this.state.planStatusSelected === constants.PARTNERPLAN.STATUS.EXEMPT) &&
                <li>
                  <SelectInput
                    {...schema.planExemption}
                    error={form.planExemption.error}
                    floatedLabel
                    handleChange={this._handleSelectChange}
                    onBlur={this._handleValidation}
                    options={constants.PARTNERPLAN_LIST_OPTIONS.EXEMPTIONS} // load from BED?
                    searchable
                    valid={form.planExemption.valid}
                    value={form.planExemption.value}
                  />
                  {this.state.planStatusExemptOtherSelected &&
                  <TextInput
                    {...schema.planExemptionOther}
                    multiline
                    error={form.planExemptionOther.error}
                    focus={form.planExemptionOther.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.planExemptionOther.value}
                    valid={form.planExemptionOther.valid}
                  />}
                </li>
                }
                { (this.state.planStatusSelected === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED
                    || this.state.planStatusSelected === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED
                    || this.state.planStatusSelected === constants.PARTNERPLAN.STATUS.AGREED) &&
                    <li>
                      <Checkbox
                        {...schema.planAgreedWithCounsellee}
                        checked={!!form.planAgreedWithCounsellee.value}
                        error={form.planAgreedWithCounsellee.error}
                        handleChange={this._handleChange}
                      />
                    </li>
                }
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText} // Add validation rules
                disabled={!this.canSubmit()}
                isLarge
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

export default PartnerPlanStatusDisplayForm



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/PartnerPlanStatusDisplayForm.js